/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./DataQueryResultItem',
	'../../dashboard/queryService/QueryResultData'
], (DataQueryResultItem, QueryResultData) => {
	class DataQueryResult extends QueryResultData {

		constructor(queryResultObj, slots) {
			super(queryResultObj);
			this._slots = slots;
		}

		destroy() {
			this.properties = null;
		}

		_generateDataItemArray() {
			if(this._resultData.version && this._resultData.version!=='1') {
				throw new Error(`Unsupported result version ${this._resultData.version}`);
			}
			this._aQueryResultDataItems = [];
			if(this._resultData && this._resultData.dataItems && this._resultData.dataItems.length > 0) {
				this._resultData.dataItems.forEach(dataItem => {
					if (this._isValidDataItem(dataItem)) {
						this._aQueryResultDataItems.push(new DataQueryResultItem(dataItem, this._slots).getAPI());
					}
				});
			}
		}
	}

	return DataQueryResult;
});
